import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { FormControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { DATE_SERVICE_INTERFACE, IDateService } from '@app/@core/services/interfaces/i-date-service.inteface';
import  moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ngx-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class DatePickerComponent implements OnInit, OnDestroy {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() control: FormControl;
  @Input() min: moment.Moment = null;
  @Input() max: moment.Moment = null;
  dateFormat: string;
  subscriptions: Array<Subscription> = [];
  constructor(@Inject(DATE_SERVICE_INTERFACE) private dateService: IDateService) { }

  ngOnInit() {
    this.subscriptions.push(
      this.dateService.getDateFormat().subscribe(value => {
        this.dateFormat = value;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
